import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './IconInput.css';

const IconInput = ({
  input,
  icon,
  name,
  type,
  placeholder,
  blacklist,
  pattern,
  meta: { touched, dirty, error },
}) => {
  const inputCopy = input;
  if (!blacklist) {
    inputCopy['data-hj-whitelist'] = '';
  }
  return (
    <div className={styles.iconInputField}>
      <div className={styles.icon}>{icon}</div>
      <input
        {...inputCopy}
        className={
          (touched || dirty) && error ? styles.inputError : styles.input
        }
        type={type}
        name={name}
        placeholder={placeholder}
        pattern={pattern}
      />
      <div className={styles.errorMessage}>
        {(touched || dirty) && (error && <span>{error}</span>)}
      </div>
    </div>
  );
};

IconInput.propTypes = {
  input: PropTypes.object.isRequired,
  icon: PropTypes.element.isRequired,
  name: PropTypes.string,
  type: PropTypes.string.isRequired,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
  blacklist: PropTypes.bool,
  pattern: PropTypes.string,
};

export default IconInput;



// WEBPACK FOOTER //
// ./src/components/Forms/IconInput.jsx